import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useGoogleTagManagerStore = defineStore('googleTagManager', () => {
  const isInitialized = ref(false)

  function getScriptContent() {
    const origin = window.location.origin
    const domain_my = import.meta.env.VITE_DOMAIN_MY

    const id =
      origin == domain_my
        ? import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID_MY
        : import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID_TICKETS

    return `<!-- Google Tag Manager -->
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${id}');
        <!-- End Google Tag Manager -->`
  }

  function init() {
    if (isInitialized.value) return
    isInitialized.value = true
  }

  function event(name: string, data: any = {}) {
    if (isInitialized.value && (window as any).dataLayer) {
      ;(window as any).dataLayer.push({ event: name, ...data })
    }
  }

  function trackOrderCompleted(
    orderId: NonNullable<string>,
    total: NonNullable<number>,
    newCustomer: boolean
  ) {
    event(EventName.ORDER_COMPLETED, {
      [EventData.ORDER_ID]: orderId,
      [EventData.ORDER_TOTAL]: total,
      [EventData.NEW_CUSTOMER]: newCustomer
    })
  }

  /**
   * Reservations (e.g. Sandy Hook Beach) run a separate Google Ads campaign, so
   * they push their own event name. That keeps GTM from firing the regular
   * tickets conversion for a reservation, and the reverse.
   */
  function trackReservationCompleted(
    reservationId: NonNullable<string>,
    orderId: NonNullable<string>,
    total: NonNullable<number>,
    newCustomer: boolean
  ) {
    event(EventName.RESERVATION_COMPLETED, {
      [EventData.RESERVATION_ID]: reservationId,
      [EventData.ORDER_ID]: orderId,
      [EventData.ORDER_TOTAL]: total,
      [EventData.NEW_CUSTOMER]: newCustomer
    })
  }

  /**
   * The format of the event name is:
   * {context}.{object}.{action}.{label}
   *
   * Context: the place where the action took place: tickets, my account, pos, etc.
   * Object: the object that the action is being performed on: order, product, etc.
   * Action: the action being performed: purchased, viewed, etc.
   * Label (Optional): the label of the action: online, in-store, etc.
   */
  enum EventName {
    ORDER_COMPLETED = 'web.order.completed',
    RESERVATION_COMPLETED = 'web.reservation.completed'
  }

  enum EventData {
    ORDER_ID = 'order_id',
    ORDER_TOTAL = 'order_total',
    RESERVATION_ID = 'reservation_id',
    NEW_CUSTOMER = 'new_customer'
  }

  return { init, event, trackOrderCompleted, trackReservationCompleted, getScriptContent }
})
